module.exports = __webpack_public_path__ + "static/img/scm_wx.70229cc0.jpg";